var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoColour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 33,
    viewBox: "0 0 118 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_25333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0846 13.3515H39.1941V16.7738H36.7065V5.36328H41.3276C44.0252 5.36328 45.657 6.97634 45.657 9.30747V9.34075C45.657 11.9819 43.6208 13.3515 41.0846 13.3515ZM43.1347 9.35651C43.1347 8.2321 42.3605 7.62786 41.1158 7.62786H39.1924V11.1184H41.1644C42.4091 11.1184 43.1347 10.3671 43.1347 9.38979V9.35651Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3502 13.2694H48.323C48.5643 14.3955 49.3403 14.9822 50.4392 14.9822C51.2637 14.9822 51.8626 14.7213 52.5396 14.0855L53.9457 15.3413C53.1368 16.3518 51.9737 16.9718 50.4062 16.9718C47.8057 16.9718 45.8823 15.1294 45.8823 12.4567V12.4234C45.8823 9.92941 47.6443 7.875 50.1649 7.875C53.0569 7.875 54.3815 10.1413 54.3815 12.6178V12.6511C54.3815 12.8946 54.3658 13.0417 54.3502 13.2694ZM50.1649 9.8611C49.1459 9.8611 48.4828 10.5949 48.2901 11.7194H51.9911C51.8453 10.6125 51.1978 9.8611 50.1649 9.8611Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1628 16.9212C56.6613 16.9212 55.6423 16.3187 55.6423 14.2976V10.1555H54.6094V8.03628H55.6423V5.80322H58.0986V8.03628H60.1349V10.1555H58.0986V13.8878C58.0986 14.4587 58.3416 14.7372 58.8902 14.7372C59.3415 14.7372 59.7477 14.6233 60.1019 14.4272V16.4168C59.588 16.7268 58.9891 16.9212 58.1628 16.9212Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0848 13.2694H63.0576C63.3007 14.3955 64.0749 14.9822 65.1755 14.9822C66 14.9822 66.5972 14.7213 67.276 14.0855L68.6803 15.3413C67.8714 16.3518 66.71 16.9718 65.1425 16.9718C62.5403 16.9718 60.6187 15.1294 60.6187 12.4567V12.4234C60.6187 9.92941 62.3806 7.875 64.9012 7.875C67.7933 7.875 69.1178 10.1413 69.1178 12.6178V12.6511C69.116 12.8946 69.1004 13.0417 69.0848 13.2694ZM64.8995 9.8611C63.8822 9.8611 63.2191 10.5949 63.0247 11.7194H66.7239C66.5798 10.6125 65.9341 9.8611 64.8995 9.8611Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0617 10.4655C73.4299 10.4655 72.4283 11.4603 72.4283 13.548V16.7758H69.9702V8.03626H72.4283V9.79643C72.93 8.5897 73.7389 7.80857 75.1919 7.87338V10.4655H75.0617Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8072 16.7738V9.32323L83.6235 14.1992H83.5592L80.4085 9.37402V16.7755H77.9678V5.36328H80.6515L83.6252 10.1884L86.5988 5.36328H89.2809V16.7738H86.8072Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6464 16.7741V15.8283C95.0492 16.4974 94.2229 16.937 93.0303 16.937C91.3985 16.937 90.0566 15.9912 90.0566 14.2626V14.2293C90.0566 12.3237 91.4957 11.4428 93.5476 11.4428C94.4208 11.4428 95.0492 11.5899 95.6655 11.8018V11.6547C95.6655 10.6284 95.0353 10.0574 93.808 10.0574C92.8706 10.0574 92.2092 10.2378 91.4159 10.532L90.8014 8.64051C91.7544 8.21667 92.6918 7.93994 94.1621 7.93994C96.8459 7.93994 98.0246 9.34282 98.0246 11.7055V16.7758H95.6464V16.7741ZM95.6967 13.2537C95.2766 13.0576 94.7263 12.928 94.1291 12.928C93.0789 12.928 92.4314 13.3518 92.4314 14.1347V14.1662C92.4314 14.8353 92.98 15.2258 93.7733 15.2258C94.919 15.2258 95.6967 14.5918 95.6967 13.6933V13.2537Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.365 16.9699C100.763 16.9699 98.8564 14.9488 98.8564 12.4548V12.4215C98.8564 9.92746 100.747 7.87305 103.396 7.87305C105.028 7.87305 106.047 8.42649 106.856 9.34073L105.352 10.9713C104.802 10.3846 104.253 10.0098 103.379 10.0098C102.151 10.0098 101.278 11.1027 101.278 12.3899V12.4215C101.278 13.7578 102.137 14.8349 103.478 14.8349C104.302 14.8349 104.868 14.4759 105.463 13.9067L106.903 15.3726C106.062 16.3009 105.092 16.9699 103.365 16.9699Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3527 7.77883L10.9488 5.45996L10.8672 10.0452L16.3527 7.77883Z",
    fill: "url(#paint0_linear_401_25333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5895 10.4059H10.5877L10.6676 5.91699L5.67676 17.0105L8.69902 15.562L10.5895 10.4059Z",
    fill: "url(#paint1_linear_401_25333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1696 8.41451L24.9955 1.7784L13.9307 0.142578L16.8627 7.67016L20.1696 8.41451Z",
    fill: "url(#paint2_linear_401_25333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9238 29.4755L15.1008 32.276L24.5738 32.8172L25.6987 27.6768L13.9238 29.4755Z",
    fill: "url(#paint3_linear_401_25333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38813 17.5112L1.09863 22.2506L14.717 32.0725L12.3874 26.5293L5.38813 17.5112Z",
    fill: "url(#paint4_linear_401_25333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5205 7.54953L13.6475 0.174316L0.480469 6.94879L10.8318 5.10805L16.5205 7.54953Z",
    fill: "url(#paint5_linear_401_25333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.584 5.43359L0 7.31461L1.00163 21.9477L5.28071 17.2206L10.584 5.43359Z",
    fill: "url(#paint6_linear_401_25333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2578 19.5308H30.0648L31.3321 17.0438L27.2648 14.1084L27.2578 19.5308Z",
    fill: "url(#paint7_linear_401_25333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8916 32.6506L29.714 23.7061L29.9657 20.1577L26.0043 27.5574L24.8916 32.6506Z",
    fill: "url(#paint8_linear_401_25333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7978 27.3632L29.8408 19.8076H27.1327L20.5015 26.9026L25.7978 27.3632Z",
    fill: "url(#paint9_linear_401_25333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2644 13.7579V13.7702L31.4584 16.7949L31.974 15.7861L25.216 1.94287L20.4248 8.5317L27.2644 13.7579Z",
    fill: "url(#paint10_linear_401_25333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61084 17.3468L12.3341 26.0128L8.71816 15.8599L5.61084 17.3468Z",
    fill: "url(#paint11_linear_401_25333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2565 27.1636L12.7173 26.6084L13.8144 29.2128L24.7126 27.5472L20.2617 27.1583L20.2565 27.1636Z",
    fill: "url(#paint12_linear_401_25333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9443 23.5097H37.2881V24.5816H36.7065V21.2451H38.0102C38.781 21.2451 39.2688 21.683 39.2688 22.366C39.2688 23.1174 38.6716 23.5097 37.9443 23.5097ZM37.9616 21.7758H37.2863V22.979H37.9616C38.4026 22.979 38.6768 22.7356 38.6768 22.3783C38.6768 21.9825 38.3991 21.7758 37.9616 21.7758Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7823 24.165C41.06 24.165 41.2596 24.0616 41.4575 23.8655L41.7926 24.165C41.5565 24.4522 41.2319 24.6396 40.7718 24.6396C40.0462 24.6396 39.4907 24.1107 39.4907 23.3278C39.4907 22.6027 39.9959 22.0107 40.7111 22.0107C41.5061 22.0107 41.9071 22.6395 41.9071 23.3698C41.9071 23.4241 41.9019 23.4714 41.8967 23.5292H40.0636C40.1313 23.9391 40.4125 24.165 40.7823 24.165ZM41.3412 23.1457C41.3013 22.7744 41.0843 22.4836 40.7059 22.4836C40.357 22.4836 40.1104 22.7568 40.0584 23.1457H41.3412Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9767 23.7935C42.9767 24.0194 43.0913 24.1105 43.284 24.1105C43.4124 24.1105 43.5235 24.0807 43.6381 24.0229V24.4958C43.4957 24.5764 43.3343 24.6254 43.1225 24.6254C42.7024 24.6254 42.4056 24.4398 42.4056 23.8881V22.5605H42.0879V22.0649H42.4056V21.373H42.9767V22.0649H43.6485V22.5605H42.9767V23.7935Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1482 24.165C45.4259 24.165 45.6238 24.0616 45.8235 23.8655L46.1585 24.165C45.9224 24.4522 45.5943 24.6396 45.1378 24.6396C44.4156 24.6396 43.8584 24.1107 43.8584 23.3278C43.8584 22.6027 44.3636 22.0107 45.077 22.0107C45.8721 22.0107 46.2748 22.6395 46.2748 23.3698C46.2748 23.4241 46.2696 23.4714 46.2644 23.5292H44.4295C44.4955 23.9391 44.7802 24.165 45.1482 24.165ZM45.7072 23.1457C45.6672 22.7744 45.4503 22.4836 45.0718 22.4836C44.7229 22.4836 44.4764 22.7568 44.4243 23.1457H45.7072Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.245 24.5797H46.6738V22.063H47.245V22.6304C47.4012 22.2539 47.6894 21.9964 48.1285 22.0157V22.6269H48.0956C47.5939 22.6269 47.245 22.9562 47.245 23.6252V24.5797Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4495 23.7622H51.4304L50.3958 22.1964V24.5801H49.8247V21.2437H50.4444L51.4513 22.8234L52.4581 21.2437H53.0761V24.5801H52.4963V22.1877L51.4495 23.7622Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1074 24.5796V24.2714C54.9373 24.4763 54.6769 24.6339 54.3002 24.6339C53.8263 24.6339 53.4097 24.3642 53.4097 23.8581V23.8476C53.4097 23.3046 53.8419 23.0366 54.4217 23.0366C54.7238 23.0366 54.9182 23.0804 55.1126 23.1417V23.0804C55.1126 22.7319 54.8939 22.541 54.4981 22.541C54.2186 22.541 54.012 22.604 53.7846 22.7004L53.6284 22.2363C53.9027 22.1137 54.1717 22.0278 54.5779 22.0278C55.3157 22.0278 55.6751 22.4184 55.6751 23.0909V24.5832H55.1074V24.5796ZM55.123 23.513C54.9772 23.457 54.7741 23.4115 54.5502 23.4115C54.1926 23.4115 53.9791 23.5603 53.9791 23.8195V23.8283C53.9791 24.0665 54.1926 24.1996 54.4616 24.1996C54.8401 24.1996 55.123 23.9859 55.123 23.6724V23.513Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3328 24.6396C56.5898 24.6396 56.043 24.0529 56.043 23.3331C56.043 22.6132 56.5898 22.0107 57.338 22.0107C57.8119 22.0107 58.1035 22.1876 58.3361 22.4468L57.982 22.8339C57.8067 22.65 57.6209 22.5204 57.3345 22.5204C56.9179 22.5204 56.6158 22.8812 56.6158 23.3243C56.6158 23.7779 56.9231 24.1405 57.3623 24.1405C57.6331 24.1405 57.831 24.0109 58.0098 23.8252L58.3535 24.1667C58.107 24.4435 57.8206 24.6396 57.3328 24.6396Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3377 24.6393C59.3725 24.6393 58.6538 23.881 58.6538 22.9159C58.6538 21.9632 59.3603 21.1855 60.3602 21.1855C60.9695 21.1855 61.341 21.401 61.657 21.7057L61.2837 22.1401C61.0181 21.8914 60.7352 21.7232 60.3568 21.7232C59.7249 21.7232 59.2649 22.2487 59.2649 22.9072C59.2649 23.5657 59.7249 24.0982 60.3568 24.0982C60.763 24.0982 61.0251 23.9335 61.3063 23.6656L61.6795 24.0474C61.3358 24.4117 60.9574 24.6393 60.3377 24.6393Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6408 24.5796V24.2714C63.4707 24.4763 63.2103 24.6339 62.8336 24.6339C62.3597 24.6339 61.9448 24.3642 61.9448 23.8581V23.8476C61.9448 23.3046 62.3736 23.0366 62.9569 23.0366C63.2589 23.0366 63.4551 23.0804 63.6478 23.1417V23.0804C63.6478 22.7319 63.429 22.541 63.0333 22.541C62.7538 22.541 62.5472 22.604 62.3198 22.7004L62.1653 22.2363C62.4396 22.1137 62.7069 22.0278 63.1148 22.0278C63.8526 22.0278 64.2119 22.4184 64.2119 23.0909V24.5832H63.6408V24.5796ZM63.6565 23.513C63.5089 23.457 63.3075 23.4115 63.0836 23.4115C62.7243 23.4115 62.5107 23.5603 62.5107 23.8195V23.8283C62.5107 24.0665 62.7243 24.1996 62.9933 24.1996C63.37 24.1996 63.6547 23.9859 63.6547 23.6724V23.513H63.6565Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.667 24.5802V21.1001H65.2381V24.5802H64.667Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.71 24.5802V21.1001H66.2811V24.5802H65.71Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.399 22.0633H68.9718V24.5801H68.399V24.1895C68.2393 24.4294 68.0067 24.6326 67.6178 24.6326C67.0554 24.6326 66.729 24.2508 66.729 23.6641V22.0615H67.3019V23.4942C67.3019 23.8847 67.4946 24.1089 67.8348 24.1089C68.1664 24.1089 68.399 23.8742 68.399 23.4837V22.0633Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3745 22.0086C72.9161 22.0086 73.2477 22.3589 73.2477 22.9736V24.5779H72.6748V23.1488C72.6748 22.7477 72.4908 22.534 72.1714 22.534C71.8589 22.534 71.635 22.7547 71.635 23.1593V24.5797H71.0639V23.1453C71.0639 22.7547 70.8746 22.534 70.5587 22.534C70.241 22.534 70.024 22.7722 70.024 23.1628V24.5779H69.4512V22.0611H70.024V22.4429C70.1837 22.2188 70.4025 22.0068 70.7861 22.0068C71.1454 22.0068 71.3954 22.1837 71.5291 22.4517C71.7305 22.1872 71.9961 22.0086 72.3745 22.0086Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7542 24.6393C75.7907 24.6393 75.0703 23.881 75.0703 22.9159C75.0703 21.9632 75.7751 21.1855 76.7767 21.1855C77.3878 21.1855 77.7575 21.401 78.0717 21.7057L77.6985 22.1401C77.4329 21.8914 77.15 21.7232 76.7733 21.7232C76.1379 21.7232 75.6814 22.2487 75.6814 22.9072C75.6814 23.5657 76.1379 24.0982 76.7733 24.0982C77.1795 24.0982 77.4381 23.9335 77.7228 23.6656L78.096 24.0474C77.7523 24.4117 77.3722 24.6393 76.7542 24.6393Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0771 24.5796V24.2714C79.907 24.4763 79.6466 24.6339 79.2682 24.6339C78.796 24.6339 78.3794 24.3642 78.3794 23.8581V23.8476C78.3794 23.3046 78.8082 23.0366 79.3897 23.0366C79.6935 23.0366 79.8862 23.0804 80.0789 23.1417V23.0804C80.0789 22.7319 79.8619 22.541 79.4644 22.541C79.1849 22.541 78.9783 22.604 78.7509 22.7004L78.5946 22.2363C78.8689 22.1137 79.1363 22.0278 79.5442 22.0278C80.2802 22.0278 80.6396 22.4184 80.6396 23.0909V24.5832H80.0771V24.5796ZM80.0928 23.513C79.9452 23.457 79.7421 23.4115 79.5199 23.4115C79.1606 23.4115 78.947 23.5603 78.947 23.8195V23.8283C78.947 24.0665 79.1623 24.1996 79.4296 24.1996C79.8081 24.1996 80.0928 23.9859 80.0928 23.6724V23.513Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.693 24.5799H81.1201V22.0631H81.693V22.4536C81.8544 22.2155 82.0853 22.0088 82.4742 22.0088C83.0349 22.0088 83.3612 22.3906 83.3612 22.9791V24.5799H82.7901V23.1507C82.7901 22.7601 82.5957 22.536 82.2554 22.536C81.9256 22.536 81.693 22.7707 81.693 23.1612V24.5799Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.024 24.6396C84.281 24.6396 83.7324 24.0529 83.7324 23.3331C83.7324 22.6132 84.2827 22.0107 85.0292 22.0107C85.5013 22.0107 85.7947 22.1876 86.0256 22.4468L85.6715 22.8339C85.4961 22.65 85.3121 22.5204 85.024 22.5204C84.6073 22.5204 84.3053 22.8812 84.3053 23.3243C84.3053 23.7779 84.6125 24.1405 85.0535 24.1405C85.3225 24.1405 85.5204 24.0109 85.701 23.8252L86.0464 24.1667C85.7982 24.4435 85.51 24.6396 85.024 24.6396Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.524 24.165C87.8034 24.165 88.0013 24.0616 88.1992 23.8655L88.536 24.165C88.2982 24.4522 87.9718 24.6396 87.5153 24.6396C86.7914 24.6396 86.2324 24.1107 86.2324 23.3278C86.2324 22.6027 86.7393 22.0107 87.4545 22.0107C88.2461 22.0107 88.6488 22.6395 88.6488 23.3698C88.6488 23.4241 88.6436 23.4714 88.6402 23.5292H86.8035C86.873 23.9391 87.1542 24.165 87.524 24.165ZM88.0829 23.1457C88.0447 22.7744 87.8277 22.4836 87.4493 22.4836C87.0987 22.4836 86.8539 22.7568 86.8018 23.1457H88.0829Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6593 24.5797H89.0864V22.063H89.6593V22.6304C89.8155 22.2539 90.1054 21.9964 90.5429 22.0157V22.6269H90.5099C90.0082 22.6269 89.6575 22.9562 89.6575 23.6252V24.5797H89.6593Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7975 21.7705H92.914V22.683H94.584V23.2172H92.914V24.578H92.3325V21.2363H94.7975V21.7705Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3011 24.6345C95.539 24.6345 94.9766 24.0478 94.9766 23.3262C94.9766 22.6011 95.5442 22.0039 96.3115 22.0039C97.077 22.0039 97.6412 22.5906 97.6412 23.3157C97.6395 24.0373 97.0718 24.6345 96.3011 24.6345ZM96.3011 22.5101C95.8428 22.5101 95.5494 22.8726 95.5494 23.3175C95.5494 23.7658 95.8671 24.1336 96.3115 24.1336C96.775 24.1336 97.0684 23.7711 97.0684 23.3262C97.0666 22.8779 96.7489 22.5101 96.3011 22.5101Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6915 22.0562H100.264V24.5764H99.6915V24.1859C99.53 24.4241 99.2991 24.629 98.9103 24.629C98.3478 24.629 98.0215 24.2472 98.0215 23.6605V22.0562H98.5943V23.4888C98.5943 23.8794 98.7888 24.1053 99.129 24.1053C99.4606 24.1053 99.6915 23.8706 99.6915 23.4801V22.0562Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.382 24.5767H100.809V22.0564H101.382V22.447C101.543 22.2088 101.774 22.0039 102.163 22.0039C102.726 22.0039 103.052 22.3857 103.052 22.9724V24.5767H102.479V23.1441C102.479 22.7535 102.285 22.5276 101.944 22.5276C101.613 22.5276 101.382 22.7623 101.382 23.1528V24.5767Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.456 24.5763V24.156C105.272 24.4187 105.012 24.6289 104.604 24.6289C104.017 24.6289 103.444 24.156 103.444 23.3171C103.444 22.4764 104.007 22.0053 104.604 22.0053C105.015 22.0053 105.276 22.2154 105.456 22.4484V21.0928H106.029V24.5763H105.456ZM104.741 22.5062C104.349 22.5062 104.022 22.8109 104.022 23.3171C104.022 23.8127 104.354 24.128 104.741 24.128C105.125 24.128 105.465 23.8075 105.465 23.3171C105.465 22.8249 105.125 22.5062 104.741 22.5062Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.112 24.5763V24.2663C107.942 24.4712 107.682 24.6289 107.303 24.6289C106.831 24.6289 106.415 24.3574 106.415 23.8512V23.8425C106.415 23.2978 106.845 23.0316 107.427 23.0316C107.729 23.0316 107.923 23.0753 108.118 23.1366V23.0753C108.118 22.7268 107.901 22.5359 107.503 22.5359C107.223 22.5359 107.015 22.5972 106.788 22.6935L106.632 22.2312C106.906 22.1068 107.175 22.021 107.583 22.021C108.321 22.021 108.68 22.4116 108.68 23.0859V24.5798H108.112V24.5763ZM108.128 23.5079C107.98 23.4502 107.777 23.4081 107.555 23.4081C107.196 23.4081 106.982 23.5552 106.982 23.8144V23.8232C106.982 24.0614 107.196 24.1963 107.465 24.1963C107.843 24.1963 108.128 23.9808 108.128 23.6673V23.5079Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.838 23.7899C109.838 24.0141 109.951 24.1051 110.145 24.1051C110.274 24.1051 110.386 24.0771 110.499 24.0193V24.4922C110.357 24.5728 110.197 24.6218 109.984 24.6218C109.564 24.6218 109.265 24.4362 109.265 23.8827V22.5551H108.947V22.0595H109.265V21.3677H109.838V22.0595H110.51V22.5551H109.838V23.7899Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.883 21.6708V21.1226H111.498V21.6708H110.883ZM110.908 24.5763V22.0561H111.48V24.5763H110.908Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.216 24.6345C112.454 24.6345 111.892 24.0478 111.892 23.3262C111.892 22.6011 112.459 22.0039 113.225 22.0039C113.992 22.0039 114.555 22.5906 114.555 23.3157C114.555 24.0373 113.987 24.6345 113.216 24.6345ZM113.216 22.5101C112.758 22.5101 112.464 22.8726 112.464 23.3175C112.464 23.7658 112.782 24.1336 113.227 24.1336C113.69 24.1336 113.983 23.7711 113.983 23.3262C113.982 22.8779 113.666 22.5101 113.216 22.5101Z",
    fill: "#451D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.532 24.5767H114.959V22.0564H115.532V22.447C115.693 22.2088 115.924 22.0039 116.313 22.0039C116.875 22.0039 117.202 22.3857 117.202 22.9724V24.5767H116.629V23.1441C116.629 22.7535 116.435 22.5276 116.094 22.5276C115.763 22.5276 115.532 22.7623 115.532 23.1528V24.5767Z",
    fill: "#451D6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_401_25333",
    x1: 14.3331,
    y1: 6.27141,
    x2: 8.41428,
    y2: 9.23918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD72AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0597,
    stopColor: "#C763A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#BB4291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3178,
    stopColor: "#B42E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3988,
    stopColor: "#B12785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_401_25333",
    x1: 10.47,
    y1: 10.1174,
    x2: 1.38872,
    y2: 17.1798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD72AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0597,
    stopColor: "#C763A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#BB4291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3178,
    stopColor: "#B42E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3988,
    stopColor: "#B12785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_401_25333",
    x1: 6.75438,
    y1: 2.02701,
    x2: 28.0699,
    y2: 6.08728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD72AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0597,
    stopColor: "#C763A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#BB4291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3178,
    stopColor: "#B42E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3988,
    stopColor: "#B12785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_401_25333",
    x1: 25.6253,
    y1: 30.8406,
    x2: -4.43082,
    y2: 25.9557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD72AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0597,
    stopColor: "#C763A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#BB4291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3178,
    stopColor: "#B42E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3988,
    stopColor: "#B12785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_401_25333",
    x1: 26.388,
    y1: 25.5254,
    x2: -3.23861,
    y2: 24.2188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD72AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0597,
    stopColor: "#C763A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#BB4291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3178,
    stopColor: "#B42E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3988,
    stopColor: "#B12785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_401_25333",
    x1: 5.58939,
    y1: 3.23824,
    x2: 26.6991,
    y2: 7.78076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD72AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0597,
    stopColor: "#C763A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#BB4291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3178,
    stopColor: "#B42E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3988,
    stopColor: "#B12785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_401_25333",
    x1: 27.3128,
    y1: 15.5285,
    x2: -3.01059,
    y2: 12.9838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD72AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0597,
    stopColor: "#C763A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#BB4291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3178,
    stopColor: "#B42E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3988,
    stopColor: "#B12785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_401_25333",
    x1: 30.9513,
    y1: 15.0359,
    x2: 25.7135,
    y2: 19.0506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD72AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0597,
    stopColor: "#C763A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#BB4291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3178,
    stopColor: "#B42E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3988,
    stopColor: "#B12785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_401_25333",
    x1: 26.76,
    y1: 26.3578,
    x2: -3.91377,
    y2: 24.2943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD72AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0597,
    stopColor: "#C763A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#BB4291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3178,
    stopColor: "#B42E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3988,
    stopColor: "#B12785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_401_25333",
    x1: 20.9866,
    y1: 25.2289,
    x2: 33.8414,
    y2: 21.4409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD72AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0597,
    stopColor: "#C763A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#BB4291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3178,
    stopColor: "#B42E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3988,
    stopColor: "#B12785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_401_25333",
    x1: 7.34683,
    y1: 2.30981,
    x2: 28.5325,
    y2: 9.30926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD72AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0597,
    stopColor: "#C763A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#BB4291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3178,
    stopColor: "#B42E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3988,
    stopColor: "#B12785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_401_25333",
    x1: 6.78398,
    y1: 18.3657,
    x2: 23.1809,
    y2: 29.4308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD72AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0597,
    stopColor: "#C763A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#BB4291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3178,
    stopColor: "#B42E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3988,
    stopColor: "#B12785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_401_25333",
    x1: 5.3953,
    y1: 18.9581,
    x2: 22.6984,
    y2: 30.5069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD72AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0597,
    stopColor: "#C763A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#BB4291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3178,
    stopColor: "#B42E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3988,
    stopColor: "#B12785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532075"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_25333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117.202,
    height: 32.6744,
    fill: "white",
    transform: "translate(0 0.142578)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColour);
export default __webpack_public_path__ + "static/media/logo-colour.356999503a18fa1381d76d671b74cdf9.svg";
export { ForwardRef as ReactComponent };